import { onMounted, defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import Header2 from '@/components/layout/header2.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import SideMenu from '@/components/layout/SideMenu.vue';
import SideComponent from '@/components/common/SideComponent.vue';
import {
  normalizeNotice,
  resolveNoticeLink,
  PHONE_VERIFY_PATH,
  NOTICE_LIST_PATH,
} from '@/utils/phoneVerify';

export default defineComponent({
	components: {
		Header2,
		Menu,
		Footer,
		SideMenu,
		SideComponent,
	},
	setup() {
		const { proxy } = getCurrentInstance();
		const store = useStore();
		const router = useRouter();
		const route = useRoute();
		const data = reactive({
			showHeader: true,
			loginStyle: 'min-width:141px;',
			mobileIconStyle: 'color:rgba(223, 58, 8, 1);',
			showListIcon: true,
			detail: {
				id: '',
				title: '',
				content: '',
				type: '',
				link: '',
				created_at: '',
			},
		});
		const showMenu = ref(proxy.$menus);
		provide('showMenu', showMenu);
		const outerStyleStr = ref("position:relative;left:10%;top:40%;transform:translate(-10%,-40%);width:auto;");
		provide('outerStyleStr', outerStyleStr);
		const styleStr = ref("height:45px;");
		provide('styleStr', styleStr);
		const showSearchText = ref(false);
		provide('showSearchText', showSearchText);

		const viewBox = ref(null);
		const scroll = (val) => {
			if (val == 'top') {
				viewBox.value.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			}
		};

		const showVerifyEntry = computed(() => {
			return data.detail.type === 'phone_reverify' ||
				(data.detail.link && String(data.detail.link).indexOf('phone-verify') >= 0);
		});

		const goList = () => {
			router.push(NOTICE_LIST_PATH);
		};

		const goVerify = () => {
			const link = resolveNoticeLink(data.detail) || PHONE_VERIFY_PATH;
			if (/^https?:\/\//i.test(link)) {
				window.location.href = link;
			} else {
				router.push(link);
			}
		};

		const onContentClick = (event) => {
			const anchor = event.target?.closest?.('a');
			if (!anchor) return;
			const href = anchor.getAttribute('href') || '';
			if (!href || /^https?:\/\//i.test(href) || href.startsWith('mailto:')) return;
			if (href.startsWith('/')) {
				event.preventDefault();
				router.push(href);
			}
		};

		const fetchDetail = () => {
			const id = route.params.id;
			store.dispatch('user/NoticeDetail', { id }).then((res) => {
				const payload = res?.data && !Array.isArray(res.data) && (res.data.title || res.data.content)
					? res.data
					: res;
				data.detail = normalizeNotice(payload);
			}).catch((err) => {
				ElMessage({
					message: err?.message || err?.msg || proxy.$t('notice.empty'),
					grouping: true,
					type: 'error',
				});
			});
		};

		onMounted(() => {
			fetchDetail();
		});

		return {
			...toRefs(data),
			viewBox,
			scroll,
			showVerifyEntry,
			goList,
			goVerify,
			onContentClick,
		};
	},
});
